import { getSetDataWorkoutExerciseUtil } from '../../../model/utils'
import getCurrentWorkoutExerciseSelect from '../get-current'
import { createSelector } from 'reselect'

const getCurrentSetDataWorkoutExerciseSelect = createSelector(getCurrentWorkoutExerciseSelect,
  (workoutExercise) => {
    return getSetDataWorkoutExerciseUtil(workoutExercise)
  }
)

export default getCurrentSetDataWorkoutExerciseSelect
